// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/BatchJob.yaml
// Generated: 2026-03-16T14:33:37.490Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateBatchJob, UpdateBatchJob, BatchJob } from '@/types/core/BatchJob';

/**
 * BatchJob Service
 * CRUD operations for BatchJob via the ABP API.
 */
export const batchJobService = new EntityService<BatchJob, CreateBatchJob, UpdateBatchJob>(
  '/api/core/batchjob',
  'BatchJob',
);
